import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PlatformService } from '@panamax/app-state';
import moment from 'moment';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
})
export class CalendarComponent implements OnInit {
  @Input() dateFilter: (data: moment.Moment) => boolean;
  @Input() dateClass: (cellDate: moment.Moment, view: string) => string;
  @Input() mindLocalTime = true;
  @Input() calendarTitle: string;
  currentSelectedDate: Date | null;
  newSelectedDate: moment.Moment | null;
  formattedNewSelectedDate: moment.Moment | null;
  minDate: Date;

  constructor(
    private modalController: ModalController,
    readonly platformService: PlatformService,
  ) {}

  ngOnInit() {
    this.minDate = moment().toDate();
  }

  onSelectedChange(newDate: moment.Moment) {
    this.newSelectedDate = newDate;
    if (this.mindLocalTime) {
      this.formattedNewSelectedDate = newDate;
    } else {
      // this was added so the calendar highlights the correct day when on off-shore timezone
      this.formattedNewSelectedDate = moment.utc(
        newDate.format('YYYY-MM-DD'),
        true,
      );
    }
  }

  ionViewWillEnter() {
    this.newSelectedDate = moment.utc(this.currentSelectedDate, true);
    this.formattedNewSelectedDate = this.newSelectedDate;
  }

  async closeModal() {
    await this.modalController.dismiss();
  }

  async submitDateModal() {
    await this.modalController.dismiss({ selectedDate: this.newSelectedDate });
  }

  async submitDateMobile() {
    await this.modalController.dismiss({ selectedDate: this.newSelectedDate });
  }
}
